import React from "react";
import ErrorBoundary from "../../additional/error-boundary";
import {Navigate, Route, Routes} from "react-router-dom";
import {
  ROUTES_CALCULATION_PAGE_ARRAY,
  ROUTES_CABINET_ARRAY,
  ROUTES_APPLICATIONS_ARRAY,
  ROUTES_DEFAULT_ARRAY,
} from '../constants'
import { ROUTES } from '../../../config/constants'
import {
  LegacyCompanyApplicationDetailRedirect,
  LegacyCompanyApplicationsRedirect,
  LegacyOrdersDetailRedirect,
  LegacyOrdersListRedirect,
  legacyOrdersDetailPattern,
  legacyOrdersListPattern,
} from '../redirects/legacy-application-urls'
import Cabinet from "../../cabinet";
import NotFound from "../../additional/not-found";
import AccessWrapper from "../access-wrapper";
import Support from "../../cabinet/support";
import SupportRequestDetailsPage from "../../cabinet/support/components/request-details-page";
import SupportNewRequestPage from "../../cabinet/support/components/new-request-page";
import Notifications from '../../cabinet/notifications';
import NotificationDetails from '../../cabinet/notifications/details/index';

const Navigator = () => {

  return (
    <ErrorBoundary>
      <AccessWrapper>
        <Routes>
          <Route path='/'>
            {ROUTES_DEFAULT_ARRAY.map(route => <Route key={route.path} {...route} />)}
            {ROUTES_CALCULATION_PAGE_ARRAY.map(route => <Route key={route.path} {...route} />)}
            <Route index element={<Navigate to={`${ROUTES.CABINET}`} />} />
            <Route path={ROUTES.COMPANY} element={<Cabinet />}>
              <Route path={ROUTES.APPLICATIONS} element={<LegacyCompanyApplicationsRedirect />} />
              <Route
                path={`${ROUTES.APPLICATIONS}/:publicId`}
                element={<LegacyCompanyApplicationDetailRedirect />}
              />
              <Route path={legacyOrdersListPattern} element={<LegacyOrdersListRedirect />} />
              <Route path={legacyOrdersDetailPattern} element={<LegacyOrdersDetailRedirect />} />
              <Route path='*' element={<NotFound />} />
            </Route>
            <Route path={ROUTES.CABINET} element={<Cabinet />}>
              {ROUTES_CABINET_ARRAY.map(route => <Route key={route.path} {...route} />)}
              {ROUTES_APPLICATIONS_ARRAY.map((route) => (
                <Route key={`cabinet-applications-${route.path}`} {...route} />
              ))}
              <Route path={ROUTES.NOTIFICATIONS}>
                <Route index element={<Notifications />} />
                <Route path=':id' element={<NotificationDetails />} />
              </Route>
              <Route path={ROUTES.SUPPORT}>
                <Route index element={<Support />} />
                <Route path={ROUTES.NEW} element={<SupportNewRequestPage />} />
                <Route path=':id' element={<SupportRequestDetailsPage />} />
              </Route>
            </Route>
            <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
            <Route path='*' element={<NotFound />} />
          </Route>
        </Routes>
      </AccessWrapper>
    </ErrorBoundary>
  )
}

export default Navigator
